<!-- eslint-disable vue/html-closing-bracket-newline -->
<template>
  <div v-if="permission.access">
    <div class="row">
      <div class="col-md-8">
        <b-card no-body>
          <div class="m-2">
            <!-- Table Top -->
            <b-row>
              <!-- Per Page -->
              <b-col
                cols="12"
                md="6"
                class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
              >
                <label>Show</label>
                <!-- :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" -->
                <v-select
                  @on-change="paginateChange"
                  :options="perPageOptions"
                  v-model="search.paginate"
                  :clearable="false"
                  class="per-page-selector d-inline-block mx-50"
                />
                <label>entries</label>
              </b-col>

              <!-- Search -->
              <b-col cols="12" md="6">
                <div class="d-flex align-items-center justify-content-end">
                  <b-form-input
                    v-model="search.search_data"
                    class="d-inline-block mr-1"
                    placeholder="Search..."
                  />
                </div>
              </b-col>
            </b-row>
          </div>
          <div class="table-responsive">
            <table class="table">
              <thead>
                <tr>
                  <th class="text-center">Sl</th>
                  <th class="text-center">Icon</th>
                  <th>Title</th>
                  <th class="text-center" v-if="permission.edit">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(facility, index) in facilities.data"
                  :key="index"
                  v-if="facilities.data.length"
                >
                  <td class="align-middle text-center">
                    {{ facilities.meta.from + index }}
                  </td>
                  <td class="align-middle text-center">
                    <img :src="facility.icon" alt="" />
                  </td>
                  <td>
                    <p class="mb-0">{{ facility.title }}</p>
                  </td>
                  <td class="align-middle text-center" v-if="permission.edit">
                    <button
                      class="btn btn-primary btn-sm"
                      @click="edit(facility.id)"
                    >
                      <feather-icon icon="EditIcon" size="16" />
                    </button>
                    <button
                      v-if="permission.delete"
                      class="btn btn-danger btn-sm"
                      style="margin-left: 3px"
                      @click="Delete(facility.id)"
                    >
                      <feather-icon icon="TrashIcon" size="16" />
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="mx-2 mb-2">
            <b-row>
              <b-col
                cols="12"
                sm="6"
                class="d-flex align-items-center justify-content-center justify-content-sm-start"
              >
                <span class="text-muted"
                  >Showing
                  {{ facilities.meta.from ? facilities.meta.from : 0 }} to
                  {{ facilities.meta.to ? facilities.meta.to : 0 }} of
                  {{ facilities.meta.total ? facilities.meta.total : 0 }}
                  entries</span
                >
              </b-col>

              <b-col
                cols="12"
                sm="6"
                class="d-flex align-items-center justify-content-center justify-content-sm-end"
              >
                <pagination
                  :data="facilities"
                  @pagination-change-page="getResults"
                  align="right"
                  :show-disabled="true"
                  :limit="5"
                ></pagination>
              </b-col>
            </b-row>
          </div>
        </b-card>
      </div>
      <div class="col-md-4" v-if="permission.create || form.id != ''">
        <b-card :title="(form.id == '' ? 'Create' : 'Update') + ' Facilities'">
          <b-card-text
            ><validation-observer ref="loginValidation">
              <b-form
                class="auth-login-form mt-2"
                @submit.prevent
                enctype="multipart/form-data"
              >
                <div class="row">
                  <div class="col-md-12">
                    <!-- email -->
                    <b-form-group label="Title" label-for="name_bn">
                      <validation-provider
                        #default="{ errors }"
                        name="title"
                        rules="required"
                      >
                        <b-form-input
                          id="title"
                          v-model="form.title"
                          :state="errors.length > 0 ? false : null"
                          name="title"
                          placeholder="title"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </div>

                  <div class="col-md-12">
                    <div class="border rounded p-2 mb-2">
                      <b-media
                        no-body
                        vertical-align="center"
                        class="flex-column flex-md-row"
                      >
                        <b-media-aside>
                          <b-img
                            :src="icon"
                            height="36"
                            width="36"
                            class="rounded mr-2 mb-1 mb-md-0"
                          />
                        </b-media-aside>
                        <b-media-body>
                          <b-form-file
                            id="icon_image"
                            accept=".jpg, .png, .gif"
                            @change="loadImage($event)"
                            placeholder="Select Icon Image"
                            drop-placeholder="Drop file here..."
                          />
                        </b-media-body>
                      </b-media>
                    </div>
                  </div>
                </div>
                <!-- submit buttons -->
                <b-button
                  type="submit"
                  class="float-right"
                  variant="primary"
                  @click="validationForm"
                >
                  {{ form.id == "" ? "Create" : "Update" }}
                </b-button>
                <b-button
                  type="submit"
                  class="float-right mx-1"
                  variant="outline-primary"
                  @click="Close"
                >
                  Close
                </b-button>
              </b-form>
            </validation-observer></b-card-text
          >
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
import {
  BTabs,
  BTab,
  BCard,
  BMediaBody,
  BMediaAside,
  BMedia,
  BFormFile,
  BRow,
  BCol,
  BLink,
  BFormGroup,
  BFormInput,
  BInputGroupAppend,
  BInputGroup,
  BFormCheckbox,
  BCardText,
  BCardTitle,
  BImg,
  BForm,
  BButton,
  BFormTextarea,
} from "bootstrap-vue";
import { required } from "@validations";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import vSelect from "vue-select";
import _ from "lodash";
export default {
  data() {
    return {
      search: {
        search_data: "",
        paginate: 10,
        page: 1,
      },
      perPageOptions: [10, 25, 50, 100],
      form: {
        id: "",
        _method: "PUT",
        title: "",
        icon: "",
      },
      icon: this.$store.state.base_url + "images/department/default.png",
      facilities: {},
      permission: {
        access: false,
        create: false,
        edit: false,
        delete: false,
      },
    };
  },
  mounted() {
    this.getResults();
    this.Permission();
  },
  methods: {
    getResults(page) {
      this.search.page = page == null ? this.search.page : page;
      const queryParams = this.buildQueryParamString(this.search);
      axios
        .get(`/app/job/facilities/${queryParams}`)
        .then((res) => {
          this.facilities = res.data;
        })
        .catch((e) => {
          this.e(e.response.data.message);
        });
    },

    loadImage(e) {
      this.form.icon = e.target.files[0];
      let file = e.target.files[0];
      let reader = new FileReader();
      reader.onload = (e) => {
        this.icon = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    Update() {
      let fd = new FormData();
      fd.append("id", this.form.id);
      fd.append("_method", this.form._method);
      fd.append("title", this.form.title);
      fd.append("icon", this.form.icon);
      fd.append("_method", this.form._method);

      axios
        .post("/app/job/facilities/" + this.form.id, fd)
        .then((res) => {
          this.Close();
          this.s(res.data.message);
          this.getResults();
        })
        .catch((e) => {
          if (e.response.status === 422) {
            if (e.response.data.errors.icon)
              this.e(e.response.data.errors.icon[0]);
            if (e.response.data.errors.icon)
              this.e(e.response.data.errors.icon[0]);
          }
        });
    },

    Close() {
      this.form.id = "";
      this.form.title = "";
      this.form.icon = "";
      this.icon = this.$store.state.base_url + "images/department/default.png";
    },

    async edit(id) {
      const facility = await this.callApi("get", "/app/job/facilities/" + id);
      if (facility.status == 200) {
        this.form.id = facility.data.jobFacilities.id;
        this.form.title = facility.data.jobFacilities.title;
        this.form.icon = facility.data.jobFacilities.icon;
        this.icon =
          this.$store.state.base_url + facility.data.jobFacilities.icon;
      }
    },

    add() {
      const fd = new FormData();
      if (this.form.icon) {
        fd.append("icon", this.form.icon, this.form.icon.name);
      }
      fd.append("title", this.form.title);

      axios
        .post("/app/job/facilities", fd)
        .then((res) => {
          this.getResults();
          this.Close();
          this.s(res.data.message);
        })
        .catch((e) => {
          if (e.response.status === 422) {
            if (e.response.data.errors.icon)
              this.e(e.response.data.errors.icon[0]);
            if (e.response.data.errors.icon)
              this.e(e.response.data.errors.icon[0]);
          }
        });
    },

    async Delete(id) {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't to delete it!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.isConfirmed) {
          axios
            .delete("/app/job/facilities/" + id)
            .then((response) => {
              this.s(response.data.message);
              this.getResults();
            })
            .catch((e) => {
              this.e(e.data.error);
            });
        }
      });
    },

    validationForm() {
      this.$refs.loginValidation.validate().then((success) => {
        if (success) {
          if (this.form.id == "") {
            this.add();
          } else {
            this.Update();
          }
        }
      });
    },

    SearchData: _.debounce(function () {
      this.search.page = 1;
      this.getResults();
    }, 1000),

    // Paginate Data Gate
    paginateChange() {
      this.search.page = 1;
      this.getResults();
    },

    async Permission() {
      const permissions = await this.callApi("post", "/app/permission");
      permissions.data.permissions.forEach((permission) => {
        if (permission.slug == "job.facilities.access") {
          this.permission.access = true;
        }

        if (permission.slug == "job.facilities.create") {
          this.permission.create = true;
        }

        if (permission.slug == "job.facilities.edit") {
          this.permission.edit = true;
        }

        if (permission.slug == "job.facilities.destroy") {
          this.permission.delete = true;
        }
      });
    },
  },
  watch: {
    "search.search_data": function (val) {
      this.SearchData();
    },
    "search.paginate": function (val) {
      this.paginateChange();
    },
  },
  components: {
    vSelect,
    BCard,
    BCardText,
    BLink,
    BTabs,
    BTab,
    BMedia,
    BFormFile,
    BFormTextarea,
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BFormCheckbox,
    BCardText,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    ValidationProvider,
    ValidationObserver,
    BMediaAside,
    BMediaBody,
  },
};
</script>

<style></style>
